function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18 14.5V12H11.75V9.5H18V7L21.75 10.75L18 14.5ZM16.75 13.25V18.25H10.5V22L3 18.25V2H16.75V8.25H15.5V3.25H5.5L10.5 5.75V17H15.5V13.25H16.75Z",
    fill: "#9da3a8"
  }));
};
export default SvgComponent;
//# sourceMappingURL=Exit.js.map